var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame354190(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#41558D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14891_43410",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14891_43410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.36669 11.7776L13.8472 6.29725C14.0244 6.11992 14.2333 6.03125 14.4739 6.03125C14.7145 6.03125 14.9235 6.11992 15.1007 6.29725C15.278 6.47447 15.3667 6.68458 15.3667 6.92758C15.3667 7.17058 15.278 7.38075 15.1007 7.55808L8.99352 13.6726C8.81619 13.8499 8.60724 13.9386 8.36669 13.9386C8.12613 13.9386 7.91719 13.8499 7.73986 13.6726L4.89202 10.8247C4.71469 10.6474 4.62724 10.4373 4.62969 10.1943C4.63213 9.95125 4.72202 9.74114 4.89936 9.56392C5.07658 9.38658 5.28669 9.29792 5.52969 9.29792C5.77269 9.29792 5.98286 9.38658 6.16019 9.56392L8.36669 11.7776Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame354190);
export default __webpack_public_path__ + "static/media/Frame 354190.8290385a8d40c7f2d112a8a640d3542f.svg";
export { ForwardRef as ReactComponent };